import {
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import {
  formatUtcDate,
  standardDateFormats,
} from "@ofqual/portal-core/core/utils/dateUtils";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingDataPortalPreviousLookups } from "../../../redux/actions";
import {
  authSelector,
  dataPortalLookupListSelector,
  dataPortalPreviousListSelector,
} from "../../../redux/selectors";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { sasTokenService } from "../../../services";
import { RecentReturn } from "../../../domain/RecentReturn";

const useStyles = makeStyles((theme) => ({
  header: {
    fontWeight: "bold",
  },
  body: {
    margin: 10,
  },
  tableMultiCell: {
    display: "inline",
  },
}));

export const PreviousCollectionList: React.FC<{}> = () => {
  const items = useSelector(dataPortalPreviousListSelector);
  const { orgId } = useSelector(dataPortalLookupListSelector);
  const dispatch = useDispatch();
  const classes = useStyles();
  const { token } = useSelector(authSelector);

  useEffect(() => {
    if (!items.hasData && !!orgId)
      dispatch(loadingDataPortalPreviousLookups(Number(orgId)));
  }, [dispatch, items.hasData, orgId]);

  const onDownload = (account: string, share: string, directory: string, name: string) => {
    sasTokenService
      .getRecentReturn(
        {
          account,
          share,
          directory,
          name
        },
        { token: token }
      )
      .then((res: any) => {
        let link = document.createElement("a");
        link.target = "_blank";
        link.href = res;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(err => {
        console.error(err);
        alert("Something went wrong. Please try again later.");
      });
  };

  return (
    <>
      {items.status !== "LOADING" ? (
        items.response.length > 0 ? (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.header}>
                    Reporting Period
                  </TableCell>
                  <TableCell className={classes.header}>Collection</TableCell>
                  <TableCell className={classes.header} colSpan={12}>
                    Uploaded On
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.response.map((item: RecentReturn) => (
                  <TableRow key={item.collectionDueDate}>
                    <TableCell scope="row">{item.regulatorReference}</TableCell>
                    <TableCell scope="row">
                      {item.collectionName} 
                      <br />
                      <Typography variant="subtitle2">
                        <strong>Template name:</strong> {item.templateName}
                      </Typography>
                    </TableCell>
                    <TableCell scope="row">
                      {formatUtcDate(
                        item.collectionDueDate,
                        standardDateFormats.DATE
                      )}
                    </TableCell>
                    <TableCell>
                      {item.filePath !== null && (
                        <IconButton
                          component="label"
                          onClick={() =>
                            onDownload(item.file.storageAccount ?? "", item.file.share ?? "", item.file.directory ?? "", item.file.name ?? "")
                          }
                          data-test="downloadButton"
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography variant="h6">No data</Typography>
        )
      ) : (
        <div className={classes.body}>
          <Skeleton variant="text" height={60} />
          <Skeleton variant="text" height={60} />
          <Skeleton variant="text" height={60} />
          <br />
          <Skeleton variant="rect" height={118} />
        </div>
      )}
    </>
  );
};
